<template>
    <div>
        <el-dialog
            title="拉取公众号文章"
            :visible.sync="dialogshow"
            width="1200px"
            v-dialogDrag
            @close="close">
            <div class="head">
                <el-form label-width="100px" :inline="true" size="normal">
                    <el-form-item label="选择公众号">
                        <el-select v-model="check_official" placeholder="选择公众号" size="mini" @change="check_change">
                            <el-option :label="item.name" :value="item._id['$oid']" v-for="(item, index) in official" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="confirm" size="mini">拉取</el-button>
                    </el-form-item>
                    <!-- <el-form-item>
                        <el-button type="primary" size="mini" @click="upload" :disabled="tableData.length==0">上传保存</el-button>
                    </el-form-item> -->
                </el-form>
                
            </div>
            <div class="table-box">
                <el-table :data="tableData" 
                border 
                stripe 
                v-loading="loading"
                :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                    <el-table-column label="序号" width="60" type="index"></el-table-column>
                    <el-table-column label="标题" prop="title" show-overflow-tooltip></el-table-column>
                    <el-table-column label="作者" prop="author" width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column label="标签" prop="digest" show-overflow-tooltip></el-table-column>
                    <el-table-column label="状态" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <p class="status" :class="{'text-danger': scope.row.status=='已存在'}">{{scope.row.status}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="80">
                        <template slot-scope="s">
                            <el-button type="primary" size="mini" @click="save(s.row, s.$index)" plain>保存</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                
            </div>
            <el-pagination class="page-tion"
                @current-change="currentChange"
                layout="prev, pager, next"
                :page-size="pagesize"
                :total="total" background>
            </el-pagination>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    data() {
        return {
            path: '/project/article',
            dialogshow: true,
            pageNo: 0,
            pagesize: 10,
            total: 0,
            official: [],
            check_official: '',
            tableData: [],
            loading: false,
            city:'',
        }
    },
    mounted () {
        this.getOfficial();
        let city = this.$store.getters.getuser.city;
        if(city === '全部'){
        this.isAllCity = true;
        }else{
        this.isAllCity = false;
        this.city = city;
        }
    },
    methods: {
        save(item, index) {
            var params = {
                id: this.check_official,
                author: item.author,
                title: item.title,
                url: item.url,
                media_id: item.media_id,
                thumb_url: item.thumb_url,
                digest: item.digest,
                create_time: item.create_time,
                update_time: item.update_time,
                city: this.city,
            }
            this.$api.addArticleForofficial(params).then(
                data=>{
                    this.$message.success(data);
                    this.tableData[index].status = '已添加';
                }
            )
        },
        check_change() {
            this.tableData = [];
            this.pageNo = 0;
        },
        upload() {
            var params = {
                news: JSON.stringify(this.tableData),
                id: this.check_official,
            }
            this.loading = true;
            this.$api.addNews(params).then(
                data=>{
                    this.loading = false;
                    var i = 0;
                    for (var item of data){
                        this.tableData[i].status = item.status;
                        i++;
                    }
                    console.log(this.tableData)
                }
            )
        },
        getOfficial() {
            this.$api.getOfficial('').then(
                data=>{
                    this.official = data;
                }
            )
        },
        confirm() {
            this.pageNo = 0;
            this.getarticle();
        },
        getarticle() {
            var params = {
                id: this.check_official,
                pageNo: this.pageNo,
                pagesize: this.pagesize,
            };
            this.tableData = [];
            this.loading = true;
            this.$api.pullArticle(params).then(
                data=>{
                    this.loading = false;
                    let {total_count, item} = data;
                    this.total = total_count;

                    var co;
                    for (var li of item){
                        co = li.content;
                        for (var news of co.news_item){
                            news.create_time = co.create_time;
                            news.update_time = co.update_time;
                            news.media_id = li.media_id;
                            this.tableData.push(news);
                        }
                    }
                }
            )
        },
        close() {
            this.$router.go(-1);
        },
        currentChange(page) {
            this.pageNo = page;
            this.getarticle();
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header{
    border-bottom: 1px solid #f7f7f7;
}
</style>